// CategoriesSctSk.jsx
import React from "react";
import { Stack, Skeleton } from "@mui/material";

export default function CategoriesSctSk() {
  return (
    <Stack
      sx={{
        width: "100%",
        p: "1rem",
        mt: "1rem",
        alignItems: "center",
      }}
    >

      {/* Grid / Row Skeleton */}
      <Stack
        direction="row"
        sx={{
          width: "100%",
          // mt: 4,
          gap: "3rem",
          justifyContent: "center",
        }}
      >
        {[...Array(4)].map((_, i) => (
          <Skeleton
            key={i}
            variant="rounded"
            sx={{
              borderRadius: "1rem",
              height: { xs: "80px", sm: "100px", md: "150px", lg: "200px" , xl:"250px" },
              width: { xs: "80px", sm: "100px", md: "150px", lg: "200px" , xl:"250px" },
            }}
          />
        ))}
      </Stack>
    </Stack>
  );
}
